import { useWizard } from 'react-use-wizard';
import { useEffect, useState } from 'react';
import axios from 'axios';
function CheckoutStep({ products, designs }) {
   const { goToStep } = useWizard();

   const [isShowFirstModal, setShowFirstModal] = useState(false);
   const [isShowSecondModal, setShowSecondModal] = useState(false);
   const [totalPrice, setTotalPrice] = useState(0);
   const [formData, setFormData] = useState({
      name: '',
      phone: '',
      email: '',
      comment: '',
      promocode: '',
      is_good: false,
   });
   const [errors, setErrors] = useState({});

   const handleShowModal = (setModal) => {
      document.body.classList.add('hidden');
      setModal(true);
   };
   const handleCloseModal = (setModal) => {
      document.body.classList.remove('hidden');
      setModal(false);
   };

   const validateForm = () => {
      const newErrors = {};

      // Name validation
      if (!formData.name.trim()) {
         newErrors.name = "поле обов'язкове";
      }

      // Phone validation (accepts only numbers)
      const phoneRegex = /^\d{10}$/;
      if (!formData.phone.trim()) {
         newErrors.phone = "поле обов'язкове";
      } else if (!phoneRegex.test(formData.phone)) {
         newErrors.phone = 'номер має бути з 10 цифр';
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!formData.email.trim()) {
         newErrors.email = "поле обов'язкове";
      } else if (!emailRegex.test(formData.email)) {
         newErrors.email = 'неправильний формат';
      }

      if (!formData.is_good) {
         newErrors.is_good = 'підтвердіть згоду з умовами';
      }

      setErrors(newErrors);

      return Object.keys(newErrors).length === 0;
   };

   const handleChange = e => {
      const { name, value, checked } = e.target;
      setFormData({ ...formData, [name]: name === 'is_good' ? checked : value });
      setErrors({ ...errors, [name]: null });
   };

   const calculateTotalPrice = async () => {
      await axios({ url: `/orders/calculate`, method: 'POST', data: prepareData(products) }).then(response => {
         setTotalPrice(response.data.total_price);
      });
   };

   const prepareDecorationsGroup = () => {
      return designs.map(design => {
         return {
            id: design.id,
            name: design.name,
            decorations: design.value.map(item => item.size).filter(Boolean),
         };
      });
   };

   const prepareData = productItems => {
      const items = [...productItems].map(product => {
         return {
            item_id: product.item_id,
            color_id: product.color_id,
            quantity: product.quantity,
            sizes: product.sizes
               .filter(item => item.quantity > 0)
               .map(item => ({ size_id: item.id, quantity: item.quantity })),
            decorations: product.decorations,
         };
      });
      return { items, decoration_groups: prepareDecorationsGroup() };
   };

   useEffect(() => {
      calculateTotalPrice();
   }, []);

   const onSubmit = () => {
      if (validateForm()) {
         const payload = {
            ...prepareData(products),
            client: formData,
         };
         axios({ url: `/orders`, method: 'POST', data: payload }).then(response => {
            if (response.status === 204) {
               window.location.href = 'https://hor.clothing/pages/thank-you';
            }
         });
      }
   };
   return (
      <div className="step">
         <div className="step__container">
            <div className="step__content">
               <div className="step__hint">ваше замовлення</div>

               <div className="step__checkout">
                  <div>
                     <div className="step__checkout-products">
                        {products.map((product, index) => (
                           <div key={index} className="step__checkout-product">
                              <div className="step__checkout-product-main">
                                 <p>
                                    <span>{index + 1}.</span> {product.data.productType.name}{' '}
                                    {product.data.fashionType.name}, {product.data.clothType.name},{' '}
                                    {product.data.color.name}
                                 </p>

                                 <div className="step__checkout-product-sizes">
                                    {product.sizes
                                       .filter(size => size.quantity)
                                       .map(size => (
                                          <div key={size.id} className="step__checkout-product-size">
                                             <p>{size.size}</p> - <p>{size.quantity}</p>
                                          </div>
                                       ))}
                                 </div>

                                 {product.decorations.length > 1 && (
                                    <div className="step__checkout-product-decorations">
                                       <span>дизайни</span>
                                       <div className="step__checkout-product-sizes">
                                          {product.decorations
                                             .filter(group => group.group_id !== 0)
                                             .map(group => (
                                                <div key={`group-${group.id}`} className="step__checkout-product-size">
                                                   <p>“{designs.find(design => design.id === group.group_id).name}”</p>
                                                   {' - '}
                                                   <p>{group.quantity}</p>
                                                </div>
                                             ))}
                                       </div>
                                    </div>
                                 )}
                              </div>
                              <div className="step__checkout-product-total">
                                 <div className="">
                                    <p>{product.quantity} шт.</p>
                                    <div className="step__checkout-product-total-price">
                                       {product.clothes_price} грн.
                                    </div>
                                 </div>
                                 {product.decorations.length > 1 && (
                                    <div className="step__checkout-product-design-total">
                                       <span>
                                          {product.decorations
                                             .filter(decoration => decoration.group_id !== 0)
                                             .reduce((acc, size) => acc + size.quantity, 0)}{' '}
                                          шт.
                                       </span>

                                       <div className="step__checkout-product-total-price">
                                          {product.decorations_price} грн.
                                       </div>
                                    </div>
                                 )}
                              </div>
                           </div>
                        ))}
                        <div className="step__checkout-product">
                           <div className="step__checkout-product-main">СУМА</div>
                           <div className="step__checkout-product-total">
                              <div className="step__checkout-product-total-price">{totalPrice} грн.</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="step__checkout-form-wrap">
                     <div className="step__checkout-form">
                        <div className="step__checkout-form-item">
                           <label>ПІБ</label>
                           <input type="text" name="name" value={formData.name} onChange={handleChange} />
                           {errors.name && <p className="error">{errors.name}</p>}
                        </div>

                        <div className="step__checkout-form-item">
                           <label>номер телефону</label>
                           <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                           {errors.phone && <p className="error">{errors.phone}</p>}
                        </div>

                        <div className="step__checkout-form-item">
                           <label>пошта</label>
                           <input type="text" name="email" value={formData.email} onChange={handleChange} />
                           {errors.email && <p className="error">{errors.email}</p>}
                        </div>

                        <div className="step__checkout-form-item">
                           <label>коментар</label>
                           <textarea name="comment" value={formData.comment} onChange={handleChange} />
                        </div>

                        <div className="step__checkout-form-item">
                           <label>промокод</label>
                           <input type="text" name="promocode" value={formData.promocode} onChange={handleChange} />
                        </div>

                        <div className="step__checkout-form-item">
                           <label htmlFor="is_good">
                              <input
                                 type="checkbox"
                                 name="is_good"
                                 id="is_good"
                                 value={formData.is_good}
                                 onChange={handleChange}
                              />
                              <p className="step__checkout-form-item-terms">
                                 згоден з умовами <span onClick={() => handleShowModal(setShowFirstModal)} className="step__checkout-form-item-link">тут</span>{' '}
                                 <span onClick={() => handleShowModal(setShowSecondModal)} className="step__checkout-form-item-link">там</span>
                              </p>
                           </label>

                           {errors.is_good && <p className="error">{errors.is_good}</p>}
                        </div>
                     </div>
                     <button className="step__checkout-prev-btn" onClick={() => goToStep(4)}>
                        повернутись до редагування
                     </button>
                     <button className="step__checkout-submit-btn" onClick={onSubmit}>
                        оформити заявку
                     </button>
                  </div>
               </div>
            </div>
         </div>
         {isShowFirstModal && (
            <div>
               <div className="step__modal">
                  <p>1 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, w</p>
               </div>
               <div className="step__modal-overlay" onClick={() => handleCloseModal(setShowFirstModal)}></div>
            </div>
         )}
         {isShowSecondModal && (
            <div>
               <div className="step__modal">
                  <p>2 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, w</p>
               </div>
               <div className="step__modal-overlay" onClick={() => handleCloseModal(setShowSecondModal)}></div>
            </div>
         )}
      </div>
   );
}

export default CheckoutStep;
